const defaults = {
  toggleClass: '.dropdown__toggle',
  listClass: '.dropdown__list',
  hiddenClass: 'is-hidden'
};

class Dropdown {

  constructor (element) {
    this.dropdown = element;
    this.options = Object.assign({}, defaults);
    this.toggle = element.querySelector(this.options.toggleClass);
    this.list = element.querySelector(this.options.listClass);
  }

  addEventListeners () {
    this.toggle.addEventListener('click', () => {
      this.toggleList();
    });

    document.addEventListener('click', (event) => {
      if (event.target !== this.dropdown && !this.dropdown.contains(event.target)) {
        this.hideList();
      }
    });

    this.dropdown.addEventListener('keydown', (event) => {
      if (event.keyCode === 27) {
        this.hideList();
      }
    });
  }

  showList () {
    this.toggle.setAttribute('aria-expanded', 'true');
    this.list.classList.remove(this.options.hiddenClass);
    this.list.setAttribute('aria-hidden', 'false');
  }

  hideList () {
    this.toggle.setAttribute('aria-expanded', 'false');
    this.list.classList.add(this.options.hiddenClass);
    this.list.setAttribute('aria-hidden', 'true');
  }

  toggleList () {
    if (this.list.classList.contains(this.options.hiddenClass)) {
      this.showList();
    } else {
      this.hideList();
    }
  }

  init () {
    this.hideList();
    this.addEventListeners();
  }
}

export default Dropdown;
